import { Component, OnInit, TemplateRef } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ShipmentDetailComponent } from '../../shipment-detail/shipment-detail.component';
import { MessageService } from 'primeng/components/common/messageservice';
import { ShipmentService, RequestShipmentService, HubService, UserService, NotificationCenterService } from '../../../services/index';
import { Shipment } from '../../../models/shipment.model';
import { Constant } from '../../../infrastructure/constant';
import { User } from '../../../models';
import { PermissionService } from '../../../services/permission.service';
import { Router } from '@angular/router';
import { SelectModel } from '../../../models/select.model';
import { SearchDate } from '../../../infrastructure/searchDate.helper';
import { SignalRService } from '../../../services/signalR.service';
import { PersistenceService, StorageType } from 'angular-persistence';
// import { ShipmentDetailComponent } from '../../shipment-detail/shipment-detail.component';


@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styles: []
})

export class HeaderComponent implements OnInit {
  //#region params báic
  shipmentName: string = "Vận đơn";
  requesrShipmentName: string = "Yêu cầu";
  //#endregion
  phoneModal: BsModalRef;
  gbModelRef: BsModalRef;
  shipmentNumberSelected: string;
  userFullName: string = "";
  hubName: string = "";
  selectedShipmentType: boolean = true;
  account: User;
  listNotifications = [];
  hasNewNotification: boolean = false;
  //
  listShipmentNumberFilter: any[] = [];
  listShipmentNumber: SelectModel[] = [];
  blockSpecial: RegExp = /^[^<>*!@#$%^&*()=+|]+$/

  //
  timerFilterShipment: any;

  constructor(private authService: AuthService, private modalService: BsModalService, protected messageService: MessageService,
    private shipmentService: ShipmentService,
    private authServica: AuthService,
    private requestShipmentService: RequestShipmentService,
    public permissionService: PermissionService,
    private hubService: HubService,
    private signalRService: SignalRService,
    public router: Router,
    private persistenceService: PersistenceService,
    private notificationService: NotificationCenterService
  ) {
    this.hasNewNotification = this.persistenceService.get("hasNewNotification", StorageType.LOCAL);
    this.signalRService.checkNotification.subscribe(x => {
      if (x && x.notificationName !== 'PaymentSuccess') {
        this.persistenceService.set("hasNewNotification", true, { type: StorageType.LOCAL });
        this.hasNewNotification = true;
        this.getListNotification();
      }
    })
  }

  ngOnInit() {
    this.getListNotification();
    this.userFullName = this.authService.getFullName();
    this.authService.getAccountInfoAsync().then(x => {
      this.account = x;
      if (this.account) {
        if (this.account.hub) {
          this.hubName = this.account.hub.name;
          this.selectedHubId = this.account.hub.id;
        }

        if (this.account.role) {
          if (this.account.roles.length > 0) {
            this.account.roleName = this.account.roles.map(x => x.name).join(", ");
          }
        }
      }
      this.getListHubs();
    });
  }
  //
  modalTitle: string;
  bsModalRef: BsModalRef;
  seriNumber: any;
  tab: number = 1;
  hidden: boolean;
  //
  hubs: SelectModel[] = [];
  selectedHubId: number;
  selectedHubName: string;
  //
  public phoneNumber: string;

  public logOut() {
    this.authService.logout();
  }

  async getListHubs() {
    this.hubs = await this.hubService.getListHubByManagementHubId(this.account.managementHubId);
  }

  async onEnterSearchGB() {
    this.gbModelRef = this.modalService.show(ShipmentDetailComponent, { class: 'inmodal bounceInRight large-modal', backdrop: true, keyboard: true });
    let includes = [
      Constant.classes.includes.shipment.fromHub,
      Constant.classes.includes.shipment.toHub,
      Constant.classes.includes.shipment.fromWard,
      Constant.classes.includes.shipment.fromDistrict,
      Constant.classes.includes.shipment.fromProvince,
      Constant.classes.includes.shipment.fromHub,
      Constant.classes.includes.shipment.toWard,
      Constant.classes.includes.shipment.toDistrict,
      Constant.classes.includes.shipment.toProvince,
      Constant.classes.includes.shipment.shipmentStatus,
      Constant.classes.includes.shipment.paymentType,
      Constant.classes.includes.shipment.service,
      Constant.classes.includes.shipment.serviceDVGT,
      Constant.classes.includes.shipment.listGoods,
      Constant.classes.includes.shipment.fromHubRouting,
      Constant.classes.includes.shipment.toHubRouting,
    ];

    let data = null;
    if (this.selectedShipmentType) {
      data = await this.shipmentService.getByShipmentNumberNewAsync(this.shipmentNumberSelected.trim());
    }
    else {
      data = await this.shipmentService.getByShipmentNumberS(this.shipmentNumberSelected.trim(), true, true);
    }
    if (data) {
      if (data.typeId == 5) {
        this.tab = 2;
        this.hidden = true;

      }

      const ladingSchedule = await this.shipmentService.getGetLadingScheduleAsync(data.id);
      if (ladingSchedule) {
        data.ladingSchedules = ladingSchedule;
      }

      this.gbModelRef.content.loadData(data, this.selectedShipmentType, true);

      this.shipmentNumberSelected = null;
    } else if (!this.selectedShipmentType) {
      this.requestShipmentService.trackingShort(this.shipmentNumberSelected.trim(), includes).subscribe(
        x => {
          if (x.isSuccess == false) return;
          this.gbModelRef.content.loadData(x.data as Shipment, this.selectedShipmentType);;
          this.shipmentNumberSelected = null;
        }
      );
    }
  }
  async openModel(template: TemplateRef<any>) {
    this.seriNumber = null;
    this.modalTitle = "Kết nối port";
    this.seriNumber = this.account.seriNumber;
    this.bsModalRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-s', backdrop: 'static', keyboard: true });

  }
  save() {
    this.authServica.UpdateSeriNumber(this.seriNumber).subscribe(x => {
      if (x.isSuccess == false) return;
      this.messageService.add({
        severity: Constant.messageStatus.success, detail: "Kết nối port thành công!",
      });
      this.seriNumber = null;
      this.bsModalRef.hide();
    })
  }

  clickClearMessage() {
    this.messageService.clear();
  }

  selectedHubChange(template: TemplateRef<any>) {
    this.modalTitle = "Thay đổi đơn vị làm việc";
    this.bsModalRef = this.modalService.show(template, { class: 'inmodal bounceInRight modal-s', backdrop: 'static', keyboard: true });
  }
  cancelChangeHub() {
    this.selectedHubId = this.account.hub.id;
    const findHub = this.hubs.find(x => x.value == this.selectedHubId);
    if (findHub) {
      this.selectedHubName = findHub.label;
    }
    this.bsModalRef.hide();
  }
  async saveChangeHub() {
    this.account.hubId = this.selectedHubId;
    const res = await this.authService.updateUser(this.account);
    if (res) {
      const findHub = this.hubs.find(x => x.value == this.selectedHubId);
      if (findHub) {
        this.selectedHubName = findHub.label;
      }
      this.messageService.add({
        severity: Constant.messageStatus.success, detail: "Cập nhật thành công!",
      });
      this.bsModalRef.hide();
      window.location.reload();
    }
    else {
      this.messageService.add({
        severity: Constant.messageStatus.error, detail: "Cập nhật lỗi!",
      });
    }

  }

  keyUpEnter() {
    this.onEnterSearchGB();
  }

  async filterShipmentNumber(event: any) {
    let value = event.query;
    value = value ? value : null;
    this.shipmentNumberSelected = value;
    clearTimeout(this.timerFilterShipment);
    this.timerFilterShipment = setTimeout(async () => {
      const res = await this.shipmentService.getlistShipmentNumberFilter(value, this.selectedShipmentType);
      if (res) {
        this.listShipmentNumber = [];
        this.listShipmentNumberFilter = [];
        if (this.selectedShipmentType) {
          res.map(x => {
            let createdDate = SearchDate.formatGetDateNoTime(x.createdWhen);
            this.listShipmentNumber.push({ label: `${x.shipmentNumber} - ${createdDate}`, value: x.shipmentNumber });
            this.listShipmentNumberFilter.push(`${x.shipmentNumber} - ${createdDate}`)
          });
        }
        else {
          res.map(x => {
            let createdDate = SearchDate.formatGetDateNoTime(x.createdWhen);
            this.listShipmentNumber.push({ label: `${x.shipmentNumberS} - ${createdDate}`, value: x.shipmentNumberS })
            this.listShipmentNumberFilter.push(`${x.shipmentNumberS} - ${createdDate}`)
          });
        }
      }
    }, 1000)


  }

  async onSelectedShipmentNumber() {
    let findS = this.listShipmentNumber.find(x => x.label == this.shipmentNumberSelected);
    if (findS) {
      this.shipmentNumberSelected = findS.value;
      await this.onEnterSearchGB();
    }
    else {
      this.shipmentNumberSelected = null;
      await this.onEnterSearchGB();
    }
  }

  async getListNotification() {
    let res = await this.notificationService.getListNotification();
    if (res) {
      this.listNotifications = res;
    }
  }

  onClickBell() {
    this.persistenceService.set("hasNewNotification", false, { type: StorageType.LOCAL });
    this.hasNewNotification = false;
  }

  navigateCpn() {
    this.router.navigate(['./quan-ly-thu-tien/xac-nhan-tien-tu-nhan-vien']);
  }
}


